import type { TheCase } from './types';

export const theCase: TheCase = {
  no: "ХД-2026-0142",
  nameKo: "바양주르흐 메스암페타민 유통 조직 사건",
  nameMn: "Баянзүрх дүүргийн метамфетамин түгээлтийн бүлэглэлийн хэрэг",
  received: "2026-03-12",
  occurred: "2026-02-28",
  placeKo: "울란바토르시 바양주르흐구 13구역",
  placeMn: "Улаанбаатар хот, Баянзүрх дүүрэг, 13-р хороо",
  jurisdictionKo: "울란바토르시 경찰청",
  jurisdictionMn: "Улаанбаатар хотын цагдаагийн газар",
  teamKo: "마약범죄수사국 2팀",
  teamMn: "Мансууруулах бодистой тэмцэх газар, 2-р хэлтэс",
  lead: "Б.Ганзориг",
  co: "Д.Энхжаргал, С.Мөнхбат",
  updated: "2026-06-08 14:32",
  history: [
    { date: "2026-03-12", key: "h1" },
    { date: "2026-03-19", key: "h2" },
    { date: "2026-03-19", key: "h3" },
    { date: "2026-03-21", key: "h4" },
    { date: "2026-04-02", key: "h5" },
  ],
};
